module.exports = __webpack_public_path__ + "img/28.3343db62.jpg";